export const events = [
  {
    id: "e1",
    catId: "zongyi",
    catName: "综艺圈",
    title: "恋综《心动信号观测站》话术对线盘点：谁靠高情商圈粉，谁被全网审判",
    status: "following",
    heat: 98,
    crowd: "12.6w",
    updated: "09-08",
    summary: "新一季恋综播出过半，嘉宾之间几段名场面式的‘话术对线’持续霸榜，网友一边嗑糖一边开审判大会。",
    lead: "这一季《心动信号观测站》靠几段高能对线彻底出圈：有人一句回怼被剪成全季高光，也有人被扒出前后言行不一致，全网搬着小板凳等反转。本期我们把嘉宾交锋的关键片段、网友分歧与后续走向一次性理清楚。",
    tags: ["恋综", "话术", "高情商", "嘉宾对线"],
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20pop%20art%20editorial%20illustration%20of%20a%20neon%20heart%20and%20two%20speech%20bubbles%20colliding%2C%20melody%20red%20and%20rind%20green%20palette%20on%20cream%20paper%20background%2C%20screenprint%20texture%2C%20retro%20magazine%20collage%2C%20no%20text%20words%2C%20soft%20shapes&width=800&height=600&seq=gua-e1-cover&orientation=landscape",
    timeline: [
      { time: "第 4 期", title: "名场面爆发", desc: "两对CP在心动观察室围绕‘要不要随时报备’起争执，一句金句被剪成当季高光，相关话题冲上热搜前五。" },
      { time: "第 5 期", title: "考古回旋镖", desc: "有网友翻出某位嘉宾半年前直播时的旧言论，与原话形成反差，风向从‘嗑到了’转向‘翻车了’。" },
      { time: "本周", title: "节目组下场", desc: "官博放出未剪辑花絮回应争议，强调‘尊重真实关系发展’，网友分成护花絮派与质疑剪辑派。" },
    ],
    clues: [
      { label: "直播录像", note: "半年前直播片段被逐字比对，是回旋镖的重要物证。" },
      { label: "花絮正片", note: "节目组放出未播花絮，正片与花絮的顺序差异成为争议焦点。" },
      { label: "嘉宾小号", note: "疑似嘉宾小号深夜发动态后又删除，截图流传但真实性待核。" },
    ],
    stances: [
      { side: "护‘金句’派", ratio: 42, point: "认为高情商回怼是真性情，剪辑放大了矛盾，不该上纲上线。" },
      { side: "审判派", ratio: 38, point: "认为言行前后不一就是‘立人设’，应该被考古并接受讨论。" },
      { side: "嗑糖中立派", ratio: 20, point: "表示只想看甜甜的恋爱推进，对谁对谁错不站队。" },
    ],
  },
  {
    id: "e2",
    catId: "yinyue",
    catName: "音乐现场",
    title: "顶流演唱会门票大战：官方放量、黄牛退票与路人粉的攻防战",
    status: "boiling",
    heat: 96,
    crowd: "18.4w",
    updated: "09-08",
    summary: "一场连开多场的巡演开票，官方临时放量、黄牛集体退单，路人粉和真粉丝各有说法，票务机制再度被架到火上烤。",
    lead: "当演唱会的票像春运一样难抢，谁的手速快、谁的账号多、谁又被系统‘误伤’，就成了比台上更精彩的戏。这场开票风波把官方、黄牛、路人粉与粉丝团之间的矛盾一次性摆上台面。",
    tags: ["演唱会", "抢票", "黄牛", "票务机制"],
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20pop%20art%20illustration%20of%20a%20concert%20stage%20with%20spotlights%20and%20a%20giant%20ticket%20scanner%2C%20melon%20red%20rind%20green%20and%20cream%20paper%20palette%2C%20retro%20magazine%20collage%2C%20screenprint%20texture%2C%20bold%20shapes%2C%20no%20text&width=800&height=600&seq=gua-e2-cover&orientation=landscape",
    timeline: [
      { time: "开票当日", title: "三分钟售罄", desc: "正式票源开抢，系统一度拥堵，多数路人粉反馈‘进去就没票了’。" },
      { time: "次日", title: "官方放量", desc: "主办方宣布追加部分档位票源并开启候补，粉丝团要求公布放量规则。" },
      { time: "近日", title: "黄牛退单", desc: "部分高价转售订单被集中退款，买卖双方都指责对方‘不守规矩’。" },
    ],
    clues: [
      { label: "候补队列", note: "候补机制的先后顺序与扣款规则，成为用户讨论的重点。" },
      { label: "退单截图", note: "多张退单通知截图流传，金额与场次各不相同，需交叉验证。" },
      { label: "主办方公告", note: "主办方关于票源分配的说明，是判断放量是否公平的关键文本。" },
    ],
    stances: [
      { side: "路人粉", ratio: 45, point: "希望实名制更彻底，让真想看的人有机会，而不是陪跑。" },
      { side: "粉丝团", ratio: 33, point: "质疑放量规则不透明，要求票源流向可追溯。" },
      { side: "票务/黄牛方", ratio: 22, point: "认为市场供需决定价格，退单属于平台风控，与己无关。" },
    ],
  },
  {
    id: "e3",
    catId: "yingshi",
    catName: "影视圈",
    title: "悬疑剧《迷雾回廊》大结局引烂尾争议，编剧连夜发文回应",
    status: "reviewing",
    heat: 91,
    crowd: "9.8w",
    updated: "09-07",
    summary: "年度悬疑剧收官，开放式结局被一半人封神、一半人骂烂尾，主创连夜发长文解释创作取舍，站内两派吵到停不下来。",
    lead: "追了十集的观众，等来一个不按常理出牌的结局。有人说这是‘高级留白’，有人说这是‘没法圆就摆烂’，两边吵上了热搜。比起结局本身，主创的那封回应长文，或许更值得逐句读。",
    tags: ["悬疑剧", "烂尾", "开放式结局", "编剧回应"],
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20pop%20art%20illustration%20of%20a%20maze%20labyrinth%20door%20half%20open%20with%20soft%20light%20leaking%20through%2C%20melon%20red%20rind%20green%20and%20cream%20paper%20palette%2C%20retro%20newspaper%20collage%2C%20no%20text%2C%20screenprint%20texture&width=800&height=600&seq=gua-e3-cover&orientation=landscape",
    timeline: [
      { time: "收官当夜", title: "结局上线", desc: "大结局更新，结尾留白引发第一波争议，#迷雾回廊结局# 迅速登顶。" },
      { time: "隔日", title: "口碑分化", desc: "评分平台短时间涌入大量打分，站内评分出现‘F’型分布，两极明显。" },
      { time: "两日后", title: "长文回应", desc: "编剧发布数千字创作说明，谈留白的必要性，也承认节奏上的遗憾。" },
    ],
    clues: [
      { label: "主创长文", note: "编剧数千字回应是解读创作意图的第一手文本。" },
      { label: "删减传闻", note: "有消息称原剧本有更多收束镜头，因篇幅被删，真实性待核。" },
      { label: "预告对照", note: "片方早前预告的画面与正片不一致，被用来佐证‘改结局’。" },
    ],
    stances: [
      { side: "封神派", ratio: 40, point: "认为开放式结局给了回看空间，留白本身就是悬疑的最高级表达。" },
      { side: "烂尾派", ratio: 44, point: "认为多条埋线没有回收，是能力不足而非艺术选择。" },
      { side: "围观派", ratio: 16, point: "还没看完，等补完再决定加入哪一边。" },
    ],
  },
  {
    id: "e4",
    catId: "dianjing",
    catName: "电竞圈",
    title: "赛训内幕疑云：战队主场失利后，粉丝站联名要求公开训练记录",
    status: "following",
    heat: 85,
    crowd: "6.2w",
    updated: "09-07",
    summary: "一线战队连续两轮被爆冷击败，有内部消息流出称训练赛安排异常，多个粉丝站连夜联名，要求俱乐部给个说法。",
    lead: "成绩不好时，粉丝的第一反应永远是‘看看训练记录’。当几条模糊的内部截图开始在群里流传，一场关于赛训透明度的讨伐，就从贴吧烧到了俱乐部官微的评论区。",
    tags: ["电竞", "赛训", "战队", "粉丝联名"],
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20pop%20art%20illustration%20of%20a%20gaming%20controller%20and%20clipboard%20with%20performance%20chart%2C%20melon%20red%20rind%20green%20and%20cream%20paper%20palette%2C%20retro%20newspaper%20collage%2C%20no%20text%2C%20screenprint%20texture&width=800&height=600&seq=gua-e4-cover&orientation=landscape",
    timeline: [
      { time: "上周末", title: "两连败", desc: "常规赛接连失利，赛后采访队员状态低落，评论区开始出现不满。" },
      { time: "本周初", title: "内幕流出", desc: "疑似内部聊天记录被转发，涉及训练赛安排与选手轮换，争议升级。" },
      { time: "昨日", title: "联名诉求", desc: "多个粉丝站发布联合声明，要求公开赛训安排并对轮换给出解释。" },
    ],
    clues: [
      { label: "聊天截图", note: "流传的‘内部记录’内容模糊，真伪与来源都需要更多佐证。" },
      { label: "比赛复盘", note: "两场失利的BP与选手状态，是判断‘状态差还是安排差’的依据。" },
      { label: "俱乐部声明", note: "官方尚未正式回应，其后续口径将决定舆论走向。" },
    ],
    stances: [
      { side: "要求透明派", ratio: 47, point: "认为成绩波动背后必有训练问题，俱乐部应公开说明。" },
      { side: "理性等待派", ratio: 35, point: "认为爆料证据不足，先等官方回应再站队，避免误伤选手。" },
      { side: "心疼选手派", ratio: 18, point: "只想喊话别网暴队员，认为输赢本来就是比赛的一部分。" },
    ],
  },
  {
    id: "e5",
    catId: "wanghong",
    catName: "网红直播",
    title: "头部主播‘剧本带货’翻车复盘：一场低价宣传引发的退单潮",
    status: "reviewing",
    heat: 88,
    crowd: "11.3w",
    updated: "09-06",
    summary: "某头部主播宣称‘全网最低’的一场专场直播，被扒出同款商品另一渠道更便宜，退单潮从弹幕蔓延到售后群，剧本化带货的边界再度被讨论。",
    lead: "直播间的‘最低价’三个字，是消费者最容易上头、也最容易翻车的地方。当镜头里信誓旦旦的低价，转头就被价格对比截图打脸，主播的信任资产也在同一天缩水。",
    tags: ["直播", "剧本带货", "最低价", "退单"],
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20pop%20art%20illustration%20of%20a%20shopping%20cart%20with%20a%20huge%20price%20tag%20and%20return%20arrows%2C%20melon%20red%20rind%20green%20and%20cream%20paper%20palette%2C%20retro%20magazine%20collage%2C%20no%20text%2C%20screenprint%20texture&width=800&height=600&seq=gua-e5-cover&orientation=landscape",
    timeline: [
      { time: "直播当晚", title: "低价话术上线", desc: "主播反复强调‘亏本冲量’，部分商品上架即售罄，气氛拉满。" },
      { time: "次日上午", title: "比价截图出现", desc: "有网友晒出同款商品其他渠道的到手价，指出并非全网最低。" },
      { time: "本周", title: "退单潮蔓延", desc: "售后群涌入大量退单诉求，主播团队发布解释，舆论持续发酵。" },
    ],
    clues: [
      { label: "比价截图", note: "不同渠道到手价的对比，是判断‘最低价’是否属实的核心证据。" },
      { label: "机制说明", note: "主播团队对价格构成与补贴规则的说明，需要与截图逐条对。" },
      { label: "平台政策", note: "关于‘最低价承诺’的平台规则，决定了此事是否触及违规。" },
    ],
    stances: [
      { side: "维权派", ratio: 46, point: "认为宣传与实价不符就是误导，坚决要求按‘最低价’补差或退单。" },
      { side: "体谅派", ratio: 30, point: "认为补贴机制复杂，主播也是‘被价格方坑了’，不至于上纲上线。" },
      { side: "围观派", ratio: 24, point: "表示不买不亏，纯粹进来看看剧本怎么演。" },
    ],
  },
  {
    id: "e6",
    catId: "yingshi",
    catName: "影视圈",
    title: "古装剧选角风波：妆造路透成‘照妖镜’，男主被吐槽诈骗式官宣",
    status: "boiling",
    heat: 84,
    crowd: "7.5w",
    updated: "09-06",
    summary: "一部大制作古装剧官宣男主后，几组路透生图流出，妆造质感与精修海报差异过大，全网开启‘颜值审判’与‘导演审美’讨论。",
    lead: "路透，是剧圈最诚实的‘照妖镜’，也是粉丝最怕的‘拆台’。当精修海报与现场生图的差距被放大到全网围观，被吐槽的就不仅是演员，还有整组妆造与导演审美。",
    tags: ["古装剧", "妆造", "路透", "选角"],
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20pop%20art%20illustration%20of%20an%20ancient%20china%20hairpin%20and%20mirror%20reflection%2C%20melon%20red%20rind%20green%20and%20cream%20paper%20palette%2C%20retro%20magazine%20collage%2C%20no%20text%2C%20screenprint%20texture&width=800&height=600&seq=gua-e6-cover&orientation=landscape",
    timeline: [
      { time: "官宣当日", title: "海报惊艳", desc: "角色海报放出，精修质感获好评，播放平台预约量上涨。" },
      { time: "三日后", title: "路透流出", desc: "片场路透与同框视频曝光，妆造与海报差异引发第一波争议。" },
      { time: "本周", title: "开拍就吵", desc: "导演回应‘造型以正片为准’，粉丝与路人各执一词，话题持续在榜。" },
    ],
    clues: [
      { label: "同框视频", note: "现场拍摄视频里的妆发与打光，是判断‘海报诈骗’的关键素材。" },
      { label: "导演回应", note: "主创对‘以正片为准’的说明，是缓解还是激化争议的变量。" },
      { label: "旧作对比", note: "同一造型团队的过往作品，被用来推测成片妆造水准。" },
    ],
    stances: [
      { side: "颜值审判派", ratio: 44, point: "认为选角没考虑骨相与古装适配，妆造再救也没用。" },
      { side: "等正片派", ratio: 36, point: "认为路透不能代表成片，现在审判为时过早。" },
      { side: "造型背锅派", ratio: 20, point: "认为问题在造型师与灯光，演员本身没问题。" },
    ],
  },
  {
    id: "e7",
    catId: "yinyue",
    catName: "音乐现场",
    title: "音乐节‘歌单拼盘’事件：压轴时长缩水，观众现场喊退票",
    status: "boiling",
    heat: 82,
    crowd: "8.1w",
    updated: "09-05",
    summary: "一场千人音乐节被指宣传与实际演出名单严重不符，压轴艺人仅唱三首就走，现场观众集体喊退票，主办方深夜道歉。",
    lead: "音乐节的快乐，有一半建立在‘名单可信’上。当现场歌单与宣传海报对不上号，压轴时长又被临时压缩，观众手里的小旗子，就会变成现场最整齐的抗议声浪。",
    tags: ["音乐节", "退票", "歌单", "主办方"],
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20pop%20art%20illustration%20of%20a%20music%20festival%20stage%20with%20a%20folded%20setlist%20paper%20and%20whistles%2C%20melon%20red%20rind%20green%20and%20cream%20paper%20palette%2C%20retro%20newspaper%20collage%2C%20no%20text%2C%20screenprint%20texture&width=800&height=600&seq=gua-e7-cover&orientation=landscape",
    timeline: [
      { time: "演出当夜", title: "名单缩水", desc: "现场公布名单与早前宣传不符，压轴艺人唱三首即离场，现场哗然。" },
      { time: "当夜散场", title: "喊退票", desc: "散场后有观众录制喊退票视频，社交平台相关词条快速升温。" },
      { time: "次日", title: "深夜道歉", desc: "主办方凌晨发布致歉声明，承诺退差价，但退改细则引发新一轮讨论。" },
    ],
    clues: [
      { label: "宣传海报", note: "早前宣传名单与现场歌单的差异，是维权依据的核心对比。" },
      { label: "演出时长表", note: "现场各时段演出的实际时长记录，被用来佐证‘拼盘缩水’。" },
      { label: "主办方方案", note: "退差价与保留票根的细则，决定了维权能否落到实处。" },
    ],
    stances: [
      { side: "现场维权派", ratio: 51, point: "认为宣传欺诈就该全额退票，不能只退差价了事。" },
      { side: "主办方苦衷派", ratio: 24, point: "认为艺人档期变动不可控，主办方也是受害者，愿意接受道歉。" },
      { side: "吃瓜中立派", ratio: 25, point: "没买票，纯粹关心主办方会不会因此被拉进演出黑名单。" },
    ],
  },
  {
    id: "e8",
    catId: "wanghong",
    catName: "网红直播",
    title: "美食探店博主集体翻车：滤镜美食 vs 实拍原图，还有谁在坚守底线",
    status: "following",
    heat: 79,
    crowd: "9.0w",
    updated: "09-05",
    summary: "一批探店博主被扒出‘修图到妈不认’，同一条街不同博主给出的评价截然相反，美食探店的真实性成为平台热议话题。",
    lead: "当‘滤镜浓度’开始内卷，探店视频里冒着热气的美食，和现实端上桌的那盘菜，可能已经不是同一个物种。这场关于真实性的讨伐，正从单个博主烧到整个探店生态。",
    tags: ["探店", "滤镜", "博主翻车", "美食"],
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20pop%20art%20illustration%20of%20a%20plate%20of%20food%20with%20a%20camera%20lens%20and%20color%20filter%20sliders%2C%20melon%20red%20rind%20green%20and%20cream%20paper%20palette%2C%20retro%20newspaper%20collage%2C%20no%20text%2C%20screenprint%20texture&width=800&height=600&seq=gua-e8-cover&orientation=landscape",
    timeline: [
      { time: "本月初", title: "原图对比流出", desc: "一位博主晒出未修原图打假同行，同款菜品的精修与实拍差异曝光。" },
      { time: "本周", title: "连锁翻车", desc: "多位探店博主被网友‘考古’，评价互相矛盾，探店公信力受冲击。" },
      { time: "近日", title: "平台整治", desc: "平台升级探店内容审核，要求标注推广，博主们开始集体表忠心。" },
    ],
    clues: [
      { label: "原图直出", note: "未修原图与成片对比，是判断滤镜是否过度的最直接证据。" },
      { label: "探店履历", note: "博主过去对同一家店的评价差异，被用来分析是否存在‘恰饭’。", },
      { label: "平台规则", note: "关于广告标注与真实性审核的新规，决定了生态会往哪走。" },
    ],
    stances: [
      { side: "打假派", ratio: 49, point: "认为探店已经变成软广重灾区，应该更严格标注并处罚。" },
      { side: "博主自辩派", ratio: 26, point: "认为光线与设备差异正常，打假是‘同行内卷、借机上位’。" },
      { side: "劝退派", ratio: 25, point: "表示探店看得越来越少，不如看本地生活评论区真实评价。" },
    ],
  },
  {
    id: "e9",
    catId: "zongyi",
    catName: "综艺圈",
    title: "选秀决赛夜爆冷：黑马逆袭还是剧本预定？投票机制被拉上热搜",
    status: "reviewing",
    heat: 90,
    crowd: "15.7w",
    updated: "09-04",
    summary: "一档年度选秀决赛夜，赛前票数遥遥领先的‘大热’选手遗憾落选，名次大洗牌被指有剧本，投票算法与清票规则成最大问号。",
    lead: "选秀最刺激的不是舞台，而是决赛夜那张‘谁都猜不到’的名次表。当大热选手爆冷出局、黑马逆袭登顶，粉丝手里的票钱就变成了一连串关于‘规则’的质问。",
    tags: ["选秀", "决赛", "投票", "剧本"],
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20pop%20art%20illustration%20of%20a%20voting%20ballot%20box%20with%20confetti%20and%20a%20golden%20trophy%2C%20melon%20red%20rind%20green%20and%20cream%20paper%20palette%2C%20retro%20magazine%20collage%2C%20no%20text%2C%20screenprint%20texture&width=800&height=600&seq=gua-e9-cover&orientation=landscape",
    timeline: [
      { time: "决赛夜", title: "爆冷出局", desc: "实时榜单长期居前的大热选手未入前三，直播间弹幕瞬间刷屏‘有黑幕’。" },
      { time: "当晚", title: "算法质疑", desc: "粉丝团晒出应援数据对比，质疑清票规则与加权逻辑不透明。" },
      { time: "次日后", title: "复盘分化", desc: "黑马粉丝庆贺‘实力获胜’，大热粉丝要求公布完整票数，平台回应有限。" },
    ],
    clues: [
      { label: "应援账目", note: "粉丝团晒出的打投与票数流水，是质疑算法的基础数据。" },
      { label: "清票公告", note: "关于异常票清除的规则说明，直接决定了名次是否被认可。" },
      { label: "赛前榜单", note: "赛前多方榜单的排名，被用来判断‘爆冷’是否早有端倪。" },
    ],
    stances: [
      { side: "黑马粉丝", ratio: 36, point: "认为票数是观众一票票投出来的，质疑者应该尊重结果。" },
      { side: "大热粉丝", ratio: 42, point: "要求平台公开计票与清票明细，不接受‘含糊其辞’。" },
      { side: "纯观众", ratio: 22, point: "不追星不投票，纯粹觉得‘看粉丝破防比成团有意思’。" },
    ],
  },
];